import { useEffect } from 'react'
import { browserHistory } from 'react-router'
import { DEFAULT_TAB_KEY } from '../constants'
import { planOverridesTabPath } from '../paths'

export default function PlanOverridesIndexRedirect() {
  useEffect(() => {
    browserHistory.replace(planOverridesTabPath(DEFAULT_TAB_KEY))
  }, [])

  return null
}
